import { createGlobalStyle } from 'styled-components';

import baseline from '../shared/global/baseline';

const globalStyle = createGlobalStyle`
    ${baseline}
`;

export default globalStyle;
